import Cookies from 'js-cookie'

/**
 * URLクエリパラメータからUTMパラメータを取得してcookieに保存する
 */
export default function saveUtmParamsToCookie() {
  const utmParams = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign']
  const urlParams = new URLSearchParams(window.location.search)

  // UTMパラメータをcookieに保存（既存のcookieがない場合のみ）
  utmParams.forEach(param => {
    const value = urlParams.get(param)
    if (value && !Cookies.get(param)) {
      Cookies.set(param, value, { expires: 1 })
    }
  })

  // utm_landingパラメータ保存（既存のcookieがない場合のみ）
  if (!Cookies.get('utm_landing')) {
    const referrer = document.referrer
    const currentPath = window.location.pathname
    const currentSearch = window.location.search

    let landingPage
    if (referrer && referrer.includes('/column/')) {
      landingPage = referrer
    } else if (currentPath.startsWith('/subsidies')) {
      // 助成金DB配下のページの場合、URLパターンに応じた値を設定
      landingPage = determineSubsidyLandingValue(currentPath, currentSearch)
    } else {
      landingPage = currentPath
    }

    Cookies.set('utm_landing', landingPage, { expires: 1 })
  }
}

/**
 * 助成金DB配下のURLパターンに応じたutm_landing値を決定
 */
function determineSubsidyLandingValue(path, search) {
  // 市区町村の検索結果型: /subsidies/search_result?prefecture_id={都道府県ID}&city_id={市区町村ID}&...
  if (path === '/subsidies/search_result' && search) {
    const params = new URLSearchParams(search)
    const cityId = params.get('city_id')
    const prefectureId = params.get('prefecture_id')

    if (cityId) {
      return 'subsidy_city'
    } else if (prefectureId) {
      return 'subsidy_prefecture'
    } else {
      return 'subsidy_other'
    }
  }

  // 市区町村のディレクトリ型: /subsidies/area/{都道府県ID}/{市区町村ID}/part/{部位タイプ名}
  const cityPartMatch = path.match(/^\/subsidies\/area\/\d+\/\d+\/part\/[^/]+$/)
  if (cityPartMatch) {
    return 'subsidy_city'
  }

  // 都道府県のディレクトリ型: /subsidies/area/{都道府県ID}/part/{部位タイプ名}
  const prefecturePartMatch = path.match(/^\/subsidies\/area\/\d+\/part\/[^/]+$/)
  if (prefecturePartMatch) {
    return 'subsidy_prefecture'
  }

  // 詳細ページ: /subsidies/{country,prefecture,city,major_city}/{ID}
  const detailMatch = path.match(/^\/subsidies\/(country|prefecture|city|major_city)\/\d+$/)
  if (detailMatch) {
    return 'subsidy_detail'
  }

  // トップページ: /subsidies
  if (path === '/subsidies') {
    return 'subsidy_top'
  }

  // その他の助成金DB配下
  return 'subsidy_other'
}
